export class InputIcon
{
	static NONE = 'none'
	static EMAIL = 'email'
	static PASSWORD_LOCKED = 'password-locked'
	static PASSWORD_UNLOCKED = 'password-unlocked'
	static PHONE = 'phone'
	static EDIT = 'edit'
}